import { Box, Typography } from "@mui/material"
import React from "react"
import { IFormAreaProps } from "../FormArea/formarea.interface"
import FormComponentsView from "../FormComponents/FormComponentsView"
import { IFormFieldProps } from "../FormField/formfield.interface"
import { IFormGroupProps } from "../FormGroup/formgroup.interface"
import { IFormTemplateProps } from "./formtemplate.interface"
import { bySortValue } from "components/Form/FormTemplate/FormTemplate"
import { useTranslation } from "react-i18next"

const ViewFormTemplate: React.FC<IFormTemplateProps> = ({
  name,
  formAreas,
  translationData,
  insuranceCompletedFieldId,
  deviation
}) => {
  const { t } = useTranslation("translation")

  return (
    <>
      {name && (
        <Typography variant="h3" gutterBottom marginBottom="20px">
          {t(`${translationData?.formTypeKey}.form_key.${translationData?.formNameKey}`, name)} #{deviation?.data?.customerDeviationId}
        </Typography>
      )}
      <Typography variant="inputLabel" color="textSecondary" >
        {t("global.created_by", "Created by")}
      </Typography>
      <Typography variant="bodyMedium" gutterBottom marginBottom="20px">
        {deviation?.data?.createdByName}
      </Typography>
      {formAreas.map((area: IFormAreaProps, index: number) => (
        <>
          {area?.formGroups?.map((formGroup: IFormGroupProps) => (
            <Box marginBottom={3}>
              <Typography variant="h3" gutterBottom marginBottom="20px">
                {t(`${translationData?.formTypeKey}.${formGroup.labelKey}`, formGroup.labelDefault || "")}
              </Typography>
              {formGroup.formFields
                ?.sort(bySortValue)
                ?.map((field: IFormFieldProps) => {
                  const insuranceCompanyField = field.id === insuranceCompletedFieldId
                  if (insuranceCompanyField) return null

                  let dependencyCheck = 0
                  const parsedDependencyIds = field.dependencyIds && JSON.parse(field.dependencyIds.toString())
                  if (parsedDependencyIds) {
                    dependencyCheck = area?.formGroups?.findIndex((formGroup: IFormGroupProps) => {
                      return formGroup.formFields.find((ff: IFormFieldProps) => {
                        return parsedDependencyIds?.every((d: any) => {
                          const sameKey = d.formFieldKey === ff.formFieldKey
                          if (!sameKey) return
                          const isFalsy = d.value === false && (ff.value === "false" || ff.value === null)
                          const isTruthy = d.value === true && ff.value === "true"
                          return isTruthy || isFalsy || ff.value === d.value
                        })
                      })
                    })
                  }
                  return (
                    dependencyCheck !== -1 && (
                      <Box marginBottom={2}>
                        <FormComponentsView
                          field={field}
                          translationData={translationData}
                        />
                      </Box>
                    )
                  )
                })}
            </Box>
          ))}
        </>
      ))
      }
    </>
  )
}

export default ViewFormTemplate
